<template>
    <v-dialog v-model="$store.state.newTransact.loads" persistent min-width="1000px" transition="dialog-transition">
        <v-container fluid>
            <v-toolbar dense dark color="secondary" class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Transacting
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.state.newTransact.loads = false;"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <div class="text-center" v-if="loadProgress">
                <v-progress-linear :size="50" color="primary" indeterminate></v-progress-linear>
            </div>
            <v-card class="pb-2">
                <v-container grid-list-xs fluid>
                    <!--Table Transact By Shift  327221-->
                    <v-toolbar color="primary" height="30" dense dark>Transact By Shift</v-toolbar>
                    <div class="tbl">
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <template v-for="(titles,
                                        i) in orderHeaders">
                                        <th :key="i" :width="titles.width">
                                            {{ titles.text }}
                                        </th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(ord, i) in orders">
                                    <tr :key="i" >
                                        <!-- <td>
                                            <v-icon persistent class="mx-3" color="primary" dark @click="
                                                openModalOrder(
                                                    ord
                                                )
                                                ">mdi-open-in-new</v-icon>
                                        </td> -->

                                        <td style="text-align:center">
                                            {{ ord.OrderID }}
                                        </td>
                                        <td style="text-align:center">
                                            <v-text-field
                                            v-model="ord.LoadNum"
                                            @change="updateOrder(ord,'LoadNum')"
                                            dense
                                            hide-details
                                            ></v-text-field>
                                        </td>
                                        <td style="text-align:center">
                                            <v-text-field
                                            v-model="ord.LoadNumOrd"
                                            @change="updateOrder(ord,'LoadNumOrd')"
                                            dense
                                            hide-details
                                            ></v-text-field>
                                        </td>
                                        <td style="text-align:center;background-color:#edd480;" v-if="ord.OrderStatus ==
                                            'PRELOAD'
                                            ">
                                            {{ ord.OrderStatus }}
                                        </td>
                                        <td style="text-align:center;background-color:#cef5a9;" v-else-if="ord.OrderStatus ==
                                            'PRLDISPAT'
                                            ">
                                            {{ ord.OrderStatus }}
                                        </td>
                                        <td style="text-align:center;" v-else>
                                            {{ ord.OrderStatus }}
                                        </td>
                                        <td style="text-align:center">
                                            {{ ord.BOL }}
                                        </td>
                                        <td>{{ ord.Customer }}</td>
                                        <td>{{ ord.Terminal }}</td>
                                        <td>{{ ord.Station }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-container>
            </v-card>
        </v-container>
    </v-dialog>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
export default {
    directives: { mask },
    components: {
    },
    props: ['searchShift'],
    data: function () {
        return {
            rateInfo: [],
            loadData: false,
            loadProgress: false,
            progress: false,
            value: '',
            dlt: [],
            items: [
                {
                    text: 'Details',
                    icon: 'mdi-card-account-details-outline',
                    action: 1
                },
                { text: 'Odos', icon: 'mdi-apps-box', action: 4 },
                { text: 'Totals', icon: 'mdi-star-circle', action: 2 },
                { text: 'Other', icon: 'mdi-dots-horizontal', action: 3 }
            ],

            disabled: null,
            params: {},
            btnPayroll: true,
            selectedItem: '',
            btnRevenue: true,
            color: 'purple',
            shifts: [],
            subMenu: 1,
            title: '',
            Moq: false,
            shift: [],
            orders: [],
            revTrans: [],
            payTrans: [],
            textbox: [],
            extraRevTrans: [],
            extraPayTrans: [],
            dialog: false,
            products: [],
            PaperworkOrigin: null,
            ShiftDetail: {
                0: {
                    ShiftDetail: '',
                    Yard: '',
                    Trailer: '',
                    Driver: '',
                    Truck: '',
                    ShiftStartTime: '',

                    ShiftEndsTime: '',
                    Shift: '',
                    ShiftDate: ''
                }
            },
            finalize: null,
            orderHeaders: [
                { text: 'OrderID', value: 'OrderID', width: '1%' },
                { text: 'L1', value: 'LoadNum', width: '2%' },
                { text: 'L2', value: 'LoadNumOrd', width: '2%' },
                { text: 'OrderStatus', value: 'OrderStatus', width: '2%' },


                { text: 'BOL', value: 'BOL', width: '6%' },
                { text: 'Customer', value: 'Customer', width: '22%' },
                { text: 'Terminal', value: 'Terminal', width: '19%' },
                { text: 'Station', value: 'Station', width: '18%' },
            ],
            transHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '5%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '25%'
                },
                { text: 'Qty', value: 'Quantity', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amount', value: 'Amount', width: '5%' },
                { text: 'InvId', value: 'InvId', width: '5%' },

                {
                    text: 'Actions',
                    value: 'save',
                    sortable: false,
                    width: '15%'
                }
            ],
            transPayHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '5%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '25%'
                },
                { text: 'Qty', value: 'Quantity', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amount', value: 'Amount', width: '5%' },
                { text: 'PayId', value: 'PayId', width: '5%' },
                {
                    text: 'Actions',
                    value: 'save',
                    sortable: false,
                    width: '15%'
                }
            ]
        };
    },
    async mounted() {
        this.loadOrders();
    },
    methods: {
        openCommentMargin: function () {
            this.$store.state.transacting.marginComment = true;
        },
        openEditAssig: function () {
            this.$store.state.assignment.dialog = true;
            this.$store.state.transacting.watch = false;
        },
        loadOrderDetails: function (orderID) {
            var str = this.$store;
            this.products = [];
            this.progress = true;
            axios
                .get('order-detail/order/' + orderID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.products = response.data.data;
                    console.log(this.products);

                    this.progress = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    this.progress = false;
                });
        },
        openRates: function (itm) {
            this.rateInfo = itm;
            this.$store.state.transacting.dialogRate = true;
        },
        loadShift: async function () {
            var str = this.$store;
            console.log(this.value);
            this.loadProgress = true;
            try {
                let response = await axios.get(
                    'shift-detail/resource/' + this.searchShift,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                );
                this.ShiftDetail = response.data;
                if (this.ShiftDetail[0].Finalize == 1) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
                this.loadProgress = false;
                this.loadData = true;
                console.log(this.ShiftDetail);
            } catch (error) {
                this.loadProgress = false;
                this.loadData = false;
                console.log(error);
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Shift No Found'
                });
            }
        },
        ReadyToTransact: function (ready, id) {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                ReadyToTransact: ready,
            };
            axios
                .put('shift-detail/' + id, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        finalizeShift: function (itm) {
            var parms = {
                Finalize: itm
            };
            axios
                .put('shift-detail/' + this.searchShift, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.insertDisp(itm);
                    this.loadShiftInfo();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadOrders: function () {
            console.log('loadOrders');
            axios
                .get('order/shift/' + this.searchShift, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.orders = response.data;
                    console.log(this.orders);
                    this.loadData = true;
                    if (this.orders.length > 0) {
                        this.btnRevenue = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        insertDisp: function (itm) {
            var parms = {};
            if (itm == 1) {
                parms = {
                    Type: 'Finalize',
                    Shift: this.searchShift
                };
            } else {
                parms = {
                    Type: 'Unfinalize',
                    Shift: this.searchShift
                };
            }
            axios
                .post('disp-order/insert', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        updateOrder: function (order,type) {
            var str = this.$store;
            var parms = {};
             if(type == 'LoadNum'){
                parms.LoadNum = order.LoadNum;
             }else{
                parms.LoadNumOrd = order.LoadNumOrd;
             }
            axios
                .put('order/' + order.OrderID, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Saved'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async onFinalizeShift() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to finalize Shift #' + this.searchShift,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.finalizeShift(1);
            }
        },
        async dltTrnsConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this transaction',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteTrnsaction(itm.TranId);
            }
        },
        async onUnFinalizeShift() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to unfinalize Shift #' + this.searchShift,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.$store.state.transacting.unfinalizedCause = true;
            }
        },
        deleteTrnsaction: function (itm) {
            var str = this.$store;
            axios
                .delete('transaction/' + itm, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete transaction successful.'
                    });
                    this.$store.state.transacting.watch = true;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        calculateAmountRevenue: function (itm) {
            if (itm.TranTypeId == 5 || itm.TranTypeId == 6) {
                const amount = itm.Quantity * itm.Rate;
                itm.Amount = Number(amount.toFixed(2));
            } else {
                const amount = (itm.Quantity * itm.Rate) / 1000;
                itm.Amount = Number(amount.toFixed(2));
            }
        },

        calculateAmountExtRevenue: function (itm) {
            const amount = itm.Quantity * itm.Rate;
            itm.Amount = Number(amount.toFixed(2));
        },
        calculateAmountExtPayrol: function (itm) {
            let amount = itm.Quantity * itm.Rate;
            if (amount > 0) {
                amount = amount * -1;
            }
            itm.Amount = Number(amount.toFixed(2));
        },
        calculateAmountPayroll: function (itm) {
            if (
                itm.TranTypeId == 21 ||
                itm.TranTypeId == 22 ||
                itm.TranTypeId == 21
            ) {
                let amount = itm.Quantity * itm.Rate;
                if (amount > 0) {
                    amount = amount * -1;
                }
                itm.Amount = Number(amount.toFixed(2));
            } else {
                let amount = (itm.Quantity * itm.Rate) / 1000;
                if (amount > 0) {
                    amount = amount * -1;
                }
                itm.Amount = Number(amount.toFixed(2));
            }
            console.log(itm);
        },
        openModalOrder: function (item) {
            this.$store.state.orderInfo.orderId = item.OrderID;
            console.log(item);
            this.$store.state.posting.dialog = true;
        },
        loadPaperworkOrigin: function () {
            axios
                .get('paperwork-origin', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.PaperworkOrigin = response.data;
                    console.log(this.PaperworkOrigin);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        saveMore: function (itm) {
            console.log(itm);
            var parms = {
                AdmComments: itm.AdmComments,
                'No Rate': itm.NoRate,

                'Short Load': itm.ShortLoad,
                Other: itm.Other
            };
            console.log(parms);
            axios
                .put('shift-detail/' + itm.ShiftDetail, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        openModalNewExt: function (i, t) {
            this.$store.state.transacting.dialogAddExt = true;
            this.title = t;
            this.params = {
                id: this.searchShift,
                Type: i
            };
            this.$store.state.transacting.watch = false;
        },
        saveRevenue: function (itm) {
            console.log(itm);
            var parms = {
                Amount: itm.Amount,
                Quantity: itm.Quantity,
                Rate: itm.Rate,
                InvId: itm.InvId,
                Description: itm.Description
            };
            console.log(parms);
            axios
                .put('transaction/' + itm.TranId, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        savePayroll: function (itm) {
            console.log(itm);
            var parms = {
                Amount: itm.Amount,
                Quantity: itm.Quantity,
                Rate: itm.Rate,
                PayId: itm.PayId,
                Description: itm.Description
            };
            axios
                .put('transaction/' + itm.TranId, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.tableTrasac tr>th {
    background: #01579b;
    color: #fff;
    text-align: center;
}

table.tbl-trs {
    border-collapse: collapse;
    font-size: 12px;
    color: #000;
    width: 100%;
}

.tbl-trs,
td {
    font-size: 13px;
}

.tbl-trs input {
    color: #000;
}

.tbl-trs input {
    width: 45px;
    box-sizing: border-box;
    border: none;
    border-bottom: 2px solid #000;
}

th {
    border-collapse: collapse;
}

td {
    height: 0px;
}

td:hover {
    background: none;
}

.tbl {
    height: 200px;
    overflow: scroll;
}

.summary-color .v-input__slot label {
    color: #000;
    font-size: 10px;
}

.tableTrasac td input {
    background: #fffae8;
}
</style>
